import { render, staticRenderFns } from "./Album_Gift.vue?vue&type=template&id=2788de57&scoped=true"
import script from "./Album_Gift.vue?vue&type=script&lang=js"
export * from "./Album_Gift.vue?vue&type=script&lang=js"
import style0 from "./Album_Gift.vue?vue&type=style&index=0&id=2788de57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788de57",
  null
  
)

export default component.exports